import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AlertComponent, AlertCustomComponent } from './components';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';

@NgModule({
  declarations: [AlertComponent, AlertCustomComponent],
  imports: [CommonModule, TranslateModule, CustomModalModule],
  exports: [AlertComponent, AlertCustomComponent],
})
export class AlertModule {}
